module.exports = __webpack_public_path__ + "static/logo-chrisbakkerdak-0c8b774a2429c8d274a1ee2d65c3f37e.png";